// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { StatusChip } from '@/components/status-chip';
import {
  LINE_ITEM_STATUS_TOOLTIPS,
  PHASE_CONFIG,
  getModifierVariant,
  parseStatus,
} from '@/constants/fulfillment-order-line-item-status';
import { FulfillmentOrderLineItemStatus } from '@/constants/fulfillment-order-line-item-status-enum';
import { getStatusIcon } from '@/constants/fulfillment-order-line-item-status-icons';
import { Tooltip } from '@mui/material';
import { forwardRef } from 'react';

interface FulfillmentOrderStatusChipProps {
  status: FulfillmentOrderLineItemStatus;
}

/**
 * Status chip for fulfillment order line items.
 * Shows a tooltip describing the status on hover.
 */
export const FulfillmentOrderStatusChip = forwardRef<
  HTMLDivElement,
  FulfillmentOrderStatusChipProps
>(function FulfillmentOrderStatusChip(props, ref) {
  const { status } = props;
  const { phase, modifier } = parseStatus(status);
  const config = PHASE_CONFIG[phase];
  const variant = getModifierVariant(phase, modifier);
  const tooltip = LINE_ITEM_STATUS_TOOLTIPS[status];

  return (
    <Tooltip arrow title={tooltip}>
      <StatusChip
        ref={ref}
        icon={getStatusIcon(phase, modifier)}
        label={config.label}
        color={config.chipConfig.color}
        variant={variant}
      />
    </Tooltip>
  );
});
